import { initialExtensions } from "../utils";

export const ensureExtensionsStructure = (extensions) => ({
  active: extensions?.active ?? initialExtensions.active,
  method: extensions?.method ?? initialExtensions.method,
  url: extensions?.url ?? initialExtensions.url,
  timeout: extensions?.timeout ?? initialExtensions.timeout,
  auth: {
    ...initialExtensions.auth,
    ...extensions?.auth,
  },
  body: {
    ...initialExtensions.body,
    ...extensions?.body,
  },
  prompt: extensions?.prompt ?? initialExtensions.prompt,
  headers: extensions?.headers ?? initialExtensions.headers,
  variables: extensions?.variables ?? initialExtensions.variables,
  variables_desk:
    extensions?.variables_desk ?? initialExtensions.variables_desk,
});
